var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"max-width":_vm.maxWidth,"persistent":"","content-class":_vm.windowClass,"scrollable":_vm.scrollable},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._t("content",null,{"cancel":_vm.cancel,"data":_vm.data,"isShow":_vm.dialog,"title":_vm.title})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }